function splitWords(str) {
  return str.match(/[A-Z]{2,}(?=[A-Z][a-z]|\b|[^a-zA-Z0-9])|[A-Z]?[a-z]+[0-9]*|[A-Z]+|[0-9]+/g) ?? [];
}
export {
  splitWords
};
//# sourceMappingURL=split-words.js.map
